import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { ConvertCSVToJSONService } from '../shared/services/convert-csv-to-json.service';
import { ReviewsService } from '../../review-management/reviews.service';
import { SessionService } from 'src/app/core/backend-adapter/session.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { IAccount } from 'src/app/acct-comps/accounts.interfaces';
import { Subject } from 'rxjs';
import { AccountsService } from 'src/app/acct-comps/accounts.service';
import { ICollectionWrapper } from 'src/app/core/backend-adapter/api/api.interfaces';
import { IDates } from 'src/app/core/feature-modules/table-filter/table-filter.interfaces';
import { formatDate } from '@angular/common';
import { MapsInsightsConfigService } from '../shared/services/apple-maps-graph-config.service';
import { ReviewsConfigService } from '../shared/services/reviews-graph-config.service';
import { ViewGraphReportsService } from '../shared/services/view-graph-reports.service';
import { NotifyService } from 'src/app/core/layouts/notifications/notify/notify.service';
import { $ } from 'protractor';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);
import { environment } from 'src/environments/environment';
import { TopRightMenuBlockComponent } from 'src/app/core/layouts/menus/top-right-menu-block/top-right-menu-block.component';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-reports-tools',
  templateUrl: './reports-tools.component.html',
  styleUrls: ['./reports-tools.component.scss'],
})
export class ReportsToolsComponent implements OnInit, OnDestroy {
  @Input() disableAppleInsights: boolean;
  @Input() disableGoogleInsights: boolean;
  @Input() disableYelpInsights: boolean;
  @Input() disableBingInsights: boolean;

  public reportSource = [
    {
      id: 1,
      btnName: 'Reviews',
      btnValue: 'reviews',
    },
    {
      id: 2,
      btnName: 'Insights: Google',
      btnValue: 'google',
    },
    {
      id: 3,
      btnName: 'Insights: Apple',
      btnValue: 'apple',
    },
    /*{
      id: 4,
      btnName: 'Insights: Yelp',
      btnValue: 'yelp',
    },*/
    {
      id: 5,
      btnName: 'Insights: Bing',
      btnValue: 'bing',
    },
  ];
  public reportsType = [
    {
      id: 1,
      btnName: 'Per Account',
      btnValue: 'account',
    },
    {
      id: 2,
      btnName: 'Per Tag',
      btnValue: 'tag',
    },
    {
      id: 3,
      btnName: 'Per Location',
      btnValue: 'location',
    },
  ];
  private readonly timePeriodOptions: any[] = [
    {
      label: 'Recent',
      value: 'recent',
      items: [
        { label: 'Yesterday', value: { timeunit: 'day', periods: 'previous', code: 'day_previous' } },
        { label: 'Current week', value: { timeunit: 'week', periods: 'current', code: 'week_current' } },
        { label: 'Last week', value: { timeunit: 'week', periods: 'previous', code: 'week_previous' } },
        { label: 'Current month', value: { timeunit: 'month', periods: 'current', code: 'month_current' } },
        { label: 'Last month', value: { timeunit: 'month', periods: 'previous', code: 'month_previous' } },
        { label: 'Last 30 days (daily)', value: { timeunit: 'day', periods: 30, code: 'dat_30' } },
      ],
    },
    {
      label: 'By week',
      value: 'byWeek',
      items: [
        { label: 'Last 13 weeks (3 mo)', value: { timeunit: 'week', periods: 13, code: 'week_13' } },
        { label: 'Last 26 weeks (6 mo)', value: { timeunit: 'week', periods: 26, code: 'week_26' } },
      ],
    },
    {
      label: 'By month',
      value: 'byMonths',
      items: [
        { label: 'Last 3 months', value: { timeunit: 'month', periods: 3, code: 'month_3' } },
        { label: 'Last 6 months', value: { timeunit: 'month', periods: 6, code: 'month_6' } },
        { label: 'Last 12 months', value: { timeunit: 'month', periods: 12, code: 'month_12' } },
        { label: 'Last 24 months', value: { timeunit: 'month', periods: 24, code: 'month_24' } },
      ],
    },
    {
      label: 'By quarter',
      value: 'byQuarter',
      items: [
        { label: 'Last 4 quarters', value: { timeunit: 'quarter', periods: 4, code: 'quarter_4' } },
        { label: 'Last 8 quarters', value: { timeunit: 'quarter', periods: 8, code: 'quarter_8' } },
      ],
    },
    {
      label: 'Semi annual',
      value: 'semiAnnual',
      items: [
        { label: 'Current year', value: { timeunit: 'semi_annual', periods: 'current', code: 'semi_annual_current' } },
        { label: 'Last 2 years', value: { timeunit: 'semi_annual', periods: 2, code: 'semi_annual_2' } },
        { label: 'Last 3 years', value: { timeunit: 'semi_annual', periods: 3, code: 'semi_annual_3' } },
        { label: 'Last 4 years', value: { timeunit: 'semi_annual', periods: 4, code: 'semi_annual_4' } },
      ],
    },
    {
      label: 'All time',
      value: 'allTime',
      items: [
        { label: 'Annual', value: { timeunit: 'year', periods: 10, code: 'year_10' } },
        { label: 'Total', value: { timeunit: 'alltime', periods: 'current', code: 'alltime_current' } },
      ],
    },
    {
      label: 'Date',
      value: 'date',
      items: [{ label: 'Custom date', value: { timeunit: 'period', code: 'period' } }],
    },
  ];
  public filteredData: any[] = this.buildTimePeriodOptions('reviews');

  public actionItems = [
    {
      label: 'CSV',
      command: () => {
        this.downloadCSVFile('csv');
      },
      disabled: false,
    },
    {
      label: 'XLSX',
      command: () => {
        this.downloadXLSXFile('xls');
      },
      disabled: false,
    },
  ];
  public viewReportData: any[] = [];
  public sourceTab: string = 'reviews';
  public reportType: string = 'account';
  public selectedTimePeriod: any | undefined;
  public cols: Column[] = [];
  public first: number = 0;
  public pageSize: number = 10;
  public disableReviews: boolean = false;
  public dateValue: IDates = {
    start: null,
    end: null,
  };
  public spinnerAnimationDuration: string = '0.8s';
  public loadingReportView: boolean = false;
  public graphData: any[] = [];
  public graphConfig: any;
  public totalClicks: any = {};
  public graphLabel: string[] = [];

  private ngUnsubscribe$ = new Subject();
  private customStartDate;
  private customEndDate;
  private accountId: number;
  private userId: number;

  constructor(
    private convertCSVToJSONService: ConvertCSVToJSONService,
    private reviewsService: ReviewsService,
    private sessionService: SessionService,
    private accountsService: AccountsService,
    private mapsInsightsConfigService: MapsInsightsConfigService,
    private reviewsConfigService: ReviewsConfigService,

    private viewGraphReportsService: ViewGraphReportsService,
    private notifyService: NotifyService
  ) {}

  ngOnInit(): void {
    this.getCurrentAccountDetails();
    this.getCurrentUserDetails();

    this.selectedTimePeriod = 'month_current';
    this.sessionService
      .getSelectedAccount$()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((res: IAccount) => {
        const {
          gmb = undefined,
          appleMaps = undefined,
          yelp = undefined,
        } = typeof res?.global === 'string' ? JSON.parse(res?.global) : res?.global;
      });

    this.getAccountDetails();
  }

  private getFormatterForTitle(title: string): (value: number) => string {
    if (title === 'Average Rating Change %') {
      return (value: number) => `${value.toFixed(0)}%`;
    }

    if (title === 'Average Rating') {
      return (value: number) => value.toFixed(2);
    }

    if (title.startsWith('Total')) {
      return (value: number) => value.toFixed(0);
    }

    return (value: number) => value.toFixed(2);
  }

  public getGraphConfig(title: string): any {
    if (this.sourceTab === 'google') {
      return this.mapsInsightsConfigService.stackOptions;
    } else if (this.sourceTab === 'apple') {
      return this.mapsInsightsConfigService.stackOptions;
    } else if (this.sourceTab === 'reviews') {
      const baseOptions = this.reviewsConfigService.stackOptions;
      const config = {
        ...baseOptions,
        plugins: {
          ...baseOptions.plugins,
          datalabels: {
            ...baseOptions.plugins.datalabels,
            formatter: this.getFormatterForTitle(title),
          },
        },
      };
      return config;
    } else if (this.sourceTab === 'yelp') {
      return this.mapsInsightsConfigService.stackOptions;
    } else if (this.sourceTab === 'bing') {
      return this.mapsInsightsConfigService.stackOptions;
    }
  }
  /** Timeunits completely excluded from Apple insights. */
  private readonly unsupportedAppleTimeunits = ['day', 'week'];
  /** Individual period codes excluded from Apple insights. */
  private readonly unsupportedAppleCodes = ['month_current'];

  /**
   * Build the filtered time-period dropdown options for a given source tab.
   *
   * For Apple, excludes entire timeunits (day, week) and specific codes
   * (month_current) while preserving other month-based periods.
   *
   * @param sourceType - The active report source tab identifier.
   * @returns Grouped time-period options with empty groups removed.
   */
  private buildTimePeriodOptions(sourceType: string): any[] {
    const isApple = sourceType === 'apple';

    return this.timePeriodOptions
      .map((group) => ({
        ...group,
        items: group.items.filter((timePeriod) => {
          if (!isApple) return true;
          const { timeunit, code } = timePeriod.value ?? {};
          return (
            !this.unsupportedAppleTimeunits.includes(timeunit) &&
            !this.unsupportedAppleCodes.includes(code)
          );
        }),
      }))
      .filter((group) => group.items.length > 0);
  }

  public selectSourceType(sourceType: string): void {
    this.filteredData = this.buildTimePeriodOptions(sourceType);
    this.sourceTab = sourceType;

    const selectedPeriodCode = this.selectedTimePeriod?.value?.code;
    const hasSelectedPeriod = this.filteredData.some((group) =>
      group.items.some((timePeriod) => timePeriod.value?.code === selectedPeriodCode)
    );

    if (selectedPeriodCode && !hasSelectedPeriod) {
      this.selectedTimePeriod = this.filteredData[0]?.items?.[0];
    }
  }

  public setReportType(reportType: string): void {
    this.reportType = reportType;
  }

  public downloadCSVFile(fileType: string): void {
    let params: string;
    params = this.checkCustomDateSelection(fileType);
    const fileName = this.generateDynamicFileName();
    this.generateReport(fileType, fileName);
  }

  public downloadXLSXFile(fileType: string): void {
    let params: string;
    params = this.checkCustomDateSelection('csv');
    const fileName = this.generateDynamicFileName();
    this.generateReport(fileType, fileName);
  }

  private generateReport(downloadFileType?: string, fileName?: string): void {
    if (this.sourceTab === 'none') {
      console.error('Report Source not selected');
      return;
    }

    let { timeunit, periods, code } = this.selectedTimePeriod['value'];

    if (timeunit === 'period') {
      periods = `${this.customStartDate}_${this.customEndDate}`;
    }

    this.loadingReportView = true;

    let reportData$;

    if (this.sourceTab === 'reviews') {
      //reportData$ = this.reviewsService.generateReviewsReport(this.checkCustomDateSelection('csv'));
      reportData$ = this.reviewsService.generateReviewsReport(
        this.accountId,
        this.userId,
        this.sourceTab,
        this.reportType,
        timeunit,
        periods
      );
    } else {
      reportData$ = this.reviewsService.getExportedReport(
        this.accountId,
        this.userId,
        this.sourceTab,
        this.reportType,
        timeunit,
        periods
      );
    }

    reportData$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      (response) => {
        //const data = this.convertCSVToJSONService.csvToJson(response);
        var data = response;
        if (this.sourceTab === 'reviews') {
          data = response['data'];
        }
        if (downloadFileType === 'csv') {
          this.reviewsService.genCSVReport(data, downloadFileType, fileName);
        } else {
          this.reviewsService.exportAsExcelFile(data, fileName);
        }
        this.loadingReportView = false;
        this.notifyService.success('Report downloaded successfully');
      },
      (err) => {
        this.loadingReportView = false;
        this.notifyService.error('Error downloading report');
      }
    );
  }

  public viewReport(viewType: string): void {
    if (this.sourceTab === 'none') {
      console.error('Report Source not selected');
      return;
    }
    this.resetData();
    const config = {
      header: true,
    };

    // Display loading spinner...
    this.loadingReportView = true;

    // Reset table if table already has data.
    if (this.cols.length) {
      this.cols = [];
    }

    let { timeunit, periods, code } = this.selectedTimePeriod['value'];

    if (timeunit === 'period') {
      periods = `${this.customStartDate}_${this.customEndDate}`;
    }

    let viewReportData$;
    if (this.sourceTab === 'reviews') {
      //viewReportData$ = this.reviewsService.generateReviewsReport(this.checkCustomDateSelection('csv'));
      viewReportData$ = this.reviewsService.generateReviewsReport(
        this.accountId,
        this.userId,
        this.sourceTab,
        this.reportType,
        timeunit,
        periods
      );
    } else {
      viewReportData$ = this.reviewsService.getExportedReport(
        this.accountId,
        this.userId,
        this.sourceTab,
        this.reportType,
        timeunit,
        periods
      );
    }
    viewReportData$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(
      (response) => {
        if (viewType === 'tableView') {
          if (this.sourceTab === 'reviews') {
            const rawData = response['data'];
            const headers = rawData[0];
            const rows = rawData.slice(1);
            this.cols = headers.map((header) => ({
              field: header,
              header: header
                .replace(/_/g, ' ')
                .replace(/__/g, ' - ')
                .replace(/^./, (str) => str.toUpperCase()),
            }));
            this.viewReportData = rows.map((row) => {
              const obj = {};
              headers.forEach((key, i) => {
                obj[key] = row[i];
              });
              return obj;
            });
          } else {
            const headers = this.convertCSVToJSONService.csvToJson(response)['data'][0];
            headers.forEach((header) => {
              const field = header;
              const newHeader: string = header.replace(/_/g, ' ').replace(/__/g, ' - ');
              this.cols.push({
                field: field,
                header: `${newHeader.slice(0, 1).toUpperCase()}${newHeader.slice(1)}`,
              });
            });
            this.viewReportData = this.convertCSVToJSONService
              .csvToJson(response, config)
              ['data'].filter((data) => Object.keys(data).length > 1);
          }
        } else if (viewType === 'graphView') {
          if (this.sourceTab === 'reviews') {
            const rawData = response['data'];
            const headers = rawData[0];
            const rows = rawData.slice(1);

            const structuredData = rows.map((row) => {
              const obj = {};
              headers.forEach((key, i) => {
                obj[key] = row[i];
              });
              return obj;
            });

            const insights = this.viewGraphReportsService.mapReviewsInsights(
              structuredData,
              this.graphLabel,
              this.selectedTimePeriod
            );

            this.graphData = insights.map((insight) => ({
              ...insight,
              config: this.getGraphConfig(insight.title),
            }));
          } else {
            const data = this.convertCSVToJSONService
              .csvToJson(response, config)
              ['data'].filter((data) => Object.keys(data).length > 1);
            if (this.sourceTab === 'google') {
              const insights = this.viewGraphReportsService.mapGoogleInsightsData(
                data,
                this.graphLabel,
                this.selectedTimePeriod
              );

              this.graphData = insights.map((insight) => ({
                ...insight,
                config: this.getGraphConfig(insight.title),
              }));
            } else if (this.sourceTab === 'apple') {
              const insights = this.viewGraphReportsService.mapAppleInsightsData(
                data,
                this.graphLabel,
                this.selectedTimePeriod
              );

              this.graphData = insights.map((insight) => ({
                ...insight,
                config: this.getGraphConfig(insight.title),
              }));
            } else if (this.sourceTab === 'yelp') {
              const insights = this.viewGraphReportsService.mapYelpInsightsData(
                data,
                this.graphLabel,
                this.selectedTimePeriod
              );

              this.graphData = insights.map((insight) => ({
                ...insight,
                config: this.getGraphConfig(insight.title),
              }));
            } else if (this.sourceTab === 'bing') {
              const insights = this.viewGraphReportsService.mapBingInsightsData(
                data,
                this.graphLabel,
                this.selectedTimePeriod
              );

              this.graphData = insights.map((insight) => ({
                ...insight,
                config: this.getGraphConfig(insight.title),
              }));
            }
          }
        }

        this.loadingReportView = false;
      },
      (err) => {
        this.loadingReportView = false;
      }
    );
  }

  public pageChange(event: any): void {
    this.first = event.first;
    this.pageSize = event.rows;
  }

  private getAccountDetails(): void {
    let allAccounts: IAccount[] = [];

    this.accountsService
      .getAccounts()
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        switchMap((data: ICollectionWrapper<IAccount[]>) => {
          allAccounts = this.mapAccountsWithSubaccounts(data.collection);
          return this.sessionService.getSelectedAccount$();
        })
      )
      .subscribe((res: IAccount) => {
        const filteredAcc = allAccounts.find((acc: IAccount) => res._id === acc._id);
        this.setAccountDetails(filteredAcc);
      });
  }

  private setAccountDetails(res: IAccount): void {
    const { _subAccounts: subAccounts = undefined } = res;
    if (subAccounts) {
      const account: IAccount =
        subAccounts &&
        subAccounts?.length &&
        subAccounts.find((subAcc) => {
          const globalObject = this.parseGlobalObject(subAcc);
          const { gmb, appleMaps } = globalObject;
          if (gmb?.publish || appleMaps?.businessId) {
            return subAcc;
          }
        });

      if (account) {
        const globalObj = this.parseGlobalObject(account);
        const isDev = environment.name === 'local' || environment.name === 'development';
        // TEMPORARY: manually mock missing values
        // globalObj.appleMaps = { businessId: 'test-biz' };
        // globalObj.yelp = {
        //   publish: true,
        //   subscribeToLM: true, // or subscribeToYK
        // };
        // const isDev = false; // Temporarily set to false for testing purposes
        (this.disableReviews = false), (this.disableAppleInsights = !isDev && !globalObj?.appleMaps?.businessId);
        this.disableGoogleInsights = !isDev && !globalObj?.gmb?.publish;
        this.disableYelpInsights =
          !isDev && !(globalObj?.yelp?.publish && (globalObj?.yelp?.subscribeToLM || globalObj?.yelp?.subscribeToYK));
        this.disableBingInsights = !isDev && !globalObj?.bing?.publish;
      }
    } else {
      const newObject = this.parseGlobalObject(res);
      // TEMPORARY: manually mock missing values
      // newObject.appleMaps = { businessId: 'test-biz' };
      // newObject.yelp = {
      //   publish: true,
      //   subscribeToLM: true, // or subscribeToYK
      // };
      const isDev = environment.name === 'local' || environment.name === 'development';
      // const isDev = false; // Temporarily set to false for testing purposes
      (this.disableReviews = false),
        (this.disableReviews = false),
        (this.disableAppleInsights = !isDev && !newObject?.appleMaps?.businessId);
      this.disableGoogleInsights = !isDev && !newObject?.gmb?.publish;
      this.disableYelpInsights =
        !isDev && !(newObject?.yelp?.publish && (newObject?.yelp?.subscribeToLM || newObject?.yelp?.subscribeToYK));
      this.disableBingInsights = !isDev && !newObject?.bing?.publish;
    }
  }

  private parseGlobalObject(globalObject) {
    const result = typeof globalObject?.global === 'string' ? JSON.parse(globalObject?.global) : globalObject?.global;
    return result;
  }

  // Move this code to a service, is used in review-management.component.ts file--------
  private mapAccountsWithSubaccounts(collection): IAccount[] {
    const myCollection = collection.map((x) => Object.assign({}, x));
    const accountsTree = myCollection.reduce((acc, v: IAccount, i, array) => {
      const hasParentAccount = v._parent_id;
      if (hasParentAccount) {
        const currentlyAdded = acc.find((a) => a._id === v._parent_id);
        const parentAccount = array.find((a) => a._id === v._parent_id) || {};
        if (!parentAccount?.hasOwnProperty('_subAccounts')) parentAccount['_subAccounts'] = [];

        if (currentlyAdded) {
          currentlyAdded._subAccounts.push(v);
          currentlyAdded.hasSubAccts = true;
        } else {
          parentAccount['_subAccounts'].push(v);
          parentAccount['hasSubAccts'] = true;
          acc.push(parentAccount);
        }
      } else {
        const currentlyAdded = acc.find((a) => a._id === v._id);
        if (!currentlyAdded) {
          acc.push(v);
        }
      }
      return acc;
    }, []);

    const flattenAccounts = accountsTree.reduce((acc, v) => {
      if (v.hasOwnProperty('_subAccounts')) {
        acc.push(v);
        acc.push(...v._subAccounts.sort((a, b) => a.name.localeCompare(b.name)));
      } else {
        acc.push(v);
      }
      return acc;
    }, []);
    return flattenAccounts;
  }

  public setCustomDate(period: string): void {
    if (period === 'start') {
      this.customStartDate = formatDate(this.dateValue.start, 'yyyy-MM-dd', 'en-US').replace(/-/g, '');
    } else {
      this.customEndDate = formatDate(this.dateValue.end, 'yyyy-MM-dd', 'en-US').replace(/-/g, '');
    }
  }

  private checkCustomDateSelection(fileType: string): string {
    let params = '';

    if (this.sourceTab !== 'reviews') {
      if (this.selectedTimePeriod['value']['timeunit'] === 'period') {
        params = `${this.sourceTab}_by_${this.reportType}_${this.selectedTimePeriod['value']['timeunit']}_${this.customStartDate}_${this.customEndDate}?format=${fileType}`;
      } else {
        params = `${this.sourceTab}_by_${this.reportType}_${this.selectedTimePeriod['value']['timeunit']}?format=${fileType}`;
      }
      return params;
    } else {
      if (this.selectedTimePeriod['value']['code'] === 'period') {
        params = `${this.sourceTab}_by_${this.reportType}_${this.selectedTimePeriod['value']['code']}_${this.customStartDate}_${this.customEndDate}?format=${fileType}`;
      } else {
        params = `${this.sourceTab}_by_${this.reportType}_${this.selectedTimePeriod['value']['code']}?format=${fileType}`;
      }
      return params;
    }
  }

  private generateDynamicFileName(): string {
    if (this.sourceTab !== 'reviews') {
      return `${this.sourceTab}_by_${this.reportType}_${this.selectedTimePeriod['value']['timeunit']}`;
    } else {
      return `${this.sourceTab}_by_${this.reportType}_${this.selectedTimePeriod['value']['code']}`;
    }
  }

  public handleChange(): void {
    this.filteredData.forEach((i) => {
      i.items.forEach((j) => {
        if (this.selectedTimePeriod['value']['timeunit'] !== 'period') {
          this.graphLabel = [j.label];
        }
        if (this.selectedTimePeriod['value']['timeunit'] === 'period') {
          this.graphLabel = [
            `
          ${this.dateValue.start.getDate()}/${this.dateValue.start.getMonth()}/${this.dateValue.start.getFullYear()} -
          ${this.dateValue.end.getDate()}/${this.dateValue.end.getMonth()}/${this.dateValue.end.getFullYear()}
          `,
          ];
        }
      });
    });
  }

  /**
   * @description To reset either reports data or graph data is already present in the view.
   * @returns void
   */
  private resetData(): void {
    if (this.graphData.length) {
      this.graphData = [];
    }

    if (this.viewReportData.length) {
      this.viewReportData = [];
    }
  }

  /**
   * @description: Get the current account details.
   */
  private getCurrentAccountDetails(): void {
    this.sessionService
      .getSelectedAccount$()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((account: IAccount) => {
        this.accountId = account?._id;
      });
  }

  /**
   * @description: Get the current user details.
   * @returns: void
   * @arguments: void
   */
  private getCurrentUserDetails(): void {
    this.sessionService
      .getCurrentUser$()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((user) => {
        this.userId = user?.login?._id;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
